import React from "react";
import { SerifInfoGlyph } from "./lmGlyphs";

// Owner-only stats strip (LM design 5a/8h): a boxed "142 views | 6 contacts"
// strip with a serif-"i" + "Only you see this" reassurance. Structurally renders
// NOTHING unless the listing carries a `stats` object — the serializer omits
// `stats` for every non-owner (Invariant 12), so this component can never surface
// views/contacts to anyone but the listing agent. `expired` recolours to the muted
// variant (white box, grey numbers) and drops the reassurance note (design 5a).
const OwnerStatsStrip = ({ stats, expired = false, className = "" }) => {
  if (!stats) return null;
  const num = expired ? "text-[#71829A]" : "text-[#33475E]";
  return (
    <div
      className={`inline-flex items-center gap-3 rounded-[10px] border px-3.5 py-2 ${
        expired ? "bg-white border-[#EEF1F6]" : "bg-[#F8FAFC] border-[#EEF1F6]"
      } ${className}`}
      data-testid="owner-stats-strip"
    >
      <span className={`text-[12.5px] ${num} whitespace-nowrap`}>
        <strong className="text-[14px]">{stats.views ?? 0}</strong> views
      </span>
      <span className="w-px h-4 bg-[#E4E9F1]" />
      <span className={`text-[12.5px] ${num} whitespace-nowrap`}>
        <strong className="text-[14px]">{stats.contacts ?? 0}</strong> contact{(stats.contacts ?? 0) === 1 ? "" : "s"}
      </span>
      {!expired && (
        <span className="inline-flex items-center gap-1 text-[10.5px] text-[#98A5B8] whitespace-nowrap">
          <SerifInfoGlyph size={12} />
          Only you see this
        </span>
      )}
    </div>
  );
};

export default OwnerStatsStrip;
